var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.__('total')))]),_vm._v(" "),_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm._f("currency")(_vm.$store.state.cashControl.form.total)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }